// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"980px","desktopWidth":"1920px","paperWidthFalse":"videoDialog_paperWidthFalse__3C4xQ","root":"videoDialog_root__chyo_"};